import Section from './ui/Section';
import Reveal from './ui/Reveal';
import useCountUp from '../hooks/useCountUp';
import { computeCustomerCount } from '../lib/customers';
import porsche from '../assets/img/porsche.svg';
import paysafe from '../assets/img/paysafe.svg';
import aboutyou from '../assets/img/aboutyou.svg';
import hofmeister from '../assets/img/hofmeister.svg';

const CLIENTS = [
  { src: porsche, alt: 'Porsche' },
  { src: paysafe, alt: 'paysafecard' },
  { src: aboutyou, alt: 'About You' },
  { src: hofmeister, alt: 'Hofmeister' },
];

function Stat({ value, suffix = '', label }) {
  const [count, ref] = useCountUp(value);
  return (
    <div ref={ref} role="img" aria-label={`${value}${suffix} ${label}`}>
      <div className="font-bold font-gotham text-4xl md:text-5xl text-brand-yellow tracking-tight">
        {count.toLocaleString('en-US')}{suffix}
      </div>
      <div className="mt-2 font-avenir text-sm uppercase tracking-wider text-text-dim">{label}</div>
    </div>
  );
}

export default function Proof() {
  const customers = computeCustomerCount();
  return (
    <Section id="facts" heading="Track record" index="01">
      <Reveal>
        <p className="max-w-3xl font-avenir text-brand-light-gray md:text-lg lg:text-xl">
          Over 35 years of programming experience. Our clients range from medium-sized
          businesses and SMEs to large corporations — relying on our experience,
          professionalism and flexibility for their next project.
        </p>
      </Reveal>

      <Reveal delay={0.1}>
        <div className="mt-12 grid grid-cols-2 gap-8 md:grid-cols-3 md:gap-12">
          <Stat value={35} suffix="+" label="Years of experience" />
          <Stat value={customers} suffix="+" label="Customers served" />
          <Stat value={4} label="Industries" />
        </div>
      </Reveal>

      <Reveal delay={0.15}>
        <div className="mt-16 grid grid-cols-2 items-center gap-x-8 gap-y-12 md:grid-cols-4">
          {CLIENTS.map((c) => (
            <img
              key={c.alt}
              src={c.src}
              alt={c.alt}
              loading="lazy"
              decoding="async"
              className="mx-auto h-8 w-auto object-contain opacity-60 grayscale transition duration-300 hover:opacity-100 hover:grayscale-0 md:h-10"
            />
          ))}
        </div>
      </Reveal>
    </Section>
  );
}
